import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-4 text-center">
      <div className="w-20 h-20 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-6">
        <i className="ri-error-warning-line w-10 h-10 flex items-center justify-center text-3xl" />
      </div>
      <h1 className="font-heading text-4xl md:text-6xl font-bold text-accent-800 mb-2">
        404
      </h1>
      <h2 className="font-heading text-xl md:text-2xl font-semibold text-accent-700 mb-4">
        Page not found
      </h2>
      <p className="text-foreground-500 text-sm md:text-base max-w-md mb-8">
        The page you are looking for does not exist. It might have been moved or
        deleted.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-lg font-medium hover:bg-secondary-500 transition-colors"
      >
        <i className="ri-home-line w-4 h-4 flex items-center justify-center" />
        Back to Home
      </Link>
    </div>
  );
}